import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import httpInterceptor from '../common/APIConfig';

const initialState = {
    updateUserMessage: null,
    loading: false,
    isSuccess: false,
    error: false,
    errorMessage: null
}

export const editUser = createAsyncThunk(
        'editUser',
        async (data, {rejectWithValue}) => {

            console.log(data)
        

    try {
        const response = await httpInterceptor.patch(`/admin/users`,data)
        if (response.status === 200) {
            return response.data
        }
    }
    catch (error){
            console.log(error)
            if (!error.response){
                return rejectWithValue(error.message) 
            }
            return rejectWithValue(error.response.data)
        }
    })

export const editUserSlice = createSlice({
    name: 'editUser',
    initialState,
    error: null,
    reducers: {
        resetUpdateUser: state => {
            state.updateUserMessage = null
            state.loading = false
            state.isSuccess = false
            state.error = false
            state.errorMessage = null
        },
        resetUpdateUserError: state => {
            state.error = false
            state.errorMessage = null
        }
    },
    extraReducers: builder =>{
        builder.addCase(editUser.pending, (state) => {
            state.loading = true
        })
        builder.addCase(editUser.fulfilled, (state, action) => {
            state.loading = false
            state.updateUserMessage = action.payload
            state.isSuccess = true
            state.error = false
        })
        builder.addCase(editUser.rejected, (state, action) => {
            state.loading = false
            state.errorMessage = action.payload
            state.error = true
        })
    }
})


export const { resetUpdateUser, resetUpdateUserError } = editUserSlice.actions

export default editUserSlice.reducer